<template>
    <v-icon class="icon" @click="openHelp">mdi-help-circle-outline</v-icon>
</template>
      
<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

export default {
  name: "HelpIcon",
  props: {
    content: {
      type: String,
    },
  },
  methods: {
    openHelp() {
      this.$store.dispatch("openHelp", { content: this.content });
    },
  },
};
</script>
      
<style lang="scss" scoped>
.mdi-help-circle-outline {
  color: $qvo-color-blue-400;
}
</style>